function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 40,
  height: 40,
  rx: 16,
  fill: "#CCCCFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7222 15.6667V29H17.1667V15.6667H12.7222ZM10.5 14.5556L14.9444 9L19.3889 14.5556V31.2222H10.5V14.5556ZM28.2778 24.5556V22.3333H24.9444V20.1111H28.2778V17.8889H26.0556V15.6667H28.2778V13.4444H23.8333V29H28.2778V26.7778H26.0556V24.5556H28.2778ZM22.7222 11.2222H29.3889C29.6836 11.2222 29.9662 11.3393 30.1746 11.5477C30.3829 11.756 30.5 12.0386 30.5 12.3333V30.1111C30.5 30.4058 30.3829 30.6884 30.1746 30.8968C29.9662 31.1052 29.6836 31.2222 29.3889 31.2222H22.7222C22.4275 31.2222 22.1449 31.1052 21.9365 30.8968C21.7282 30.6884 21.6111 30.4058 21.6111 30.1111V12.3333C21.6111 12.0386 21.7282 11.756 21.9365 11.5477C22.1449 11.3393 22.4275 11.2222 22.7222 11.2222Z",
  fill: "#121221"
});

function SvgFashionDesigning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFashionDesigning);
export default __webpack_public_path__ + "static/media/FashionDesigning.d601a877.svg";
export { ForwardRef as ReactComponent };